import styled from 'styled-components/native';
import Feather from 'react-native-vector-icons/Feather';
import {RFValue} from 'react-native-responsive-fontsize';
import {css} from 'styled-components';

interface IFilterItem {
  active?: boolean;
}

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const Content = styled.View`
  flex: 1;
  padding: 0 24px;
`;

export const ContentHeader = styled.View`
  margin-bottom: ${RFValue(12)}px;
`;

export const FilterList = styled.ScrollView`
  margin: 0 -24px;
`;
export const FilterInfo = styled.View`
  flex-direction: row;
  align-items: center;
  flex: 1;
`;
export const FormFooter = styled.View`
  flex-direction: row;
  align-items: flex-end;
  margin-top: ${RFValue(12)}px;
  justify-content: flex-end;
`;
export const Filter = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
  padding: 0 24px;
  justify-content: space-between;
  height: ${RFValue(60)}px;
  border-bottom-width: 1px;
  border-bottom-color: ${({theme}) => theme.colors.border};
`;
export const FilterText = styled.Text<IFilterItem>`
  font-size: ${RFValue(14)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.blue};
  text-transform: capitalize;

  ${({active}) =>
    active &&
    css`
      font-family: ${({theme}) => theme.fonts.bold};
    `}
`;
export const Icon = styled(Feather)`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.text_dark};
`;

export const Form = styled.View`
  margin-bottom: ${RFValue(12)}px;
`;
